import angular from 'angular'
import { ILogService } from 'angular'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import AccesoServicios from 'src/_panel/module/uni-base/services/AccesoServicios'
import { RestClient } from '../../data/rest-client'
import {
  IModelMenu,
  IModelFormulario,
  IApiRestFormularios,
  IApiRestFormulariosClient,
  IApiRestCurriculums,
  IApiRestCurriculumsClient,
  IApiRestGestionCurriculums,
  IApiRestGestionCurriculumsClient,
  IApiRestLogin,
  IApiRestLoginClient,
  IApiRestMainQuestions,
  IApiRestMainQuestionsClient,
  IApiRestGestionMenu,
  IApiRestGestionMenuClient,
  IApiRestDatos,
  IApiRestDatosClient,
  IApiRestHistoricoCurriculums,
  IApiRestHistoricoCurriculumsClient,
  IApiRestGestionTextos,
  IApiRestGestionTextosClient,
  IApiRestDocumentacion,
  IApiRestDocumentacionClient,
  IApiRestGestionFormsInternos,
  IApiRestGestionFormsInternosClient,
  IApiRestMenuPublicos,
  IApiRestFormulariosPublicos,
  IApiRestMenuPublicosClient,
  IApiRestFormulariosPublicosClient,
  IApiRestHistoricoFormsInternosClient,
  IApiRestHistoricoFormsInternos,
} from 'src/model/candidato-api'
import {
  IApiRestMenu,
  IApiRestMenuClient,
  IApiRestEdicionFormularios,
  IApiRestEdicionFormulariosClient,
  IApiRestEdicionPreguntas,
  IApiRestEdicionPreguntasClient,
} from '../../../model/candidato-api'

function _detectaPath(def: string) {
  console.log('---> detectapath', window.location, process?.env)

  if ((process as any)?.browser) {
    if (window.location.href.match('http://localhost:5001')) {
      return '/pmc'
    }

    if (window.location.href.match('http://localhost:5000') || window.location.href.match(/192\.168.*5000/)) {
      return '/curr'
    }

    if ((window as any).__api) {
      return (window as any).__api
    }
  }

  return def
}

const BASE_CANDIDATO = _detectaPath('/pmc')
export const BASE_CANDIDATO_API = `${BASE_CANDIDATO}/`
const BASE_URL_REST_DATA_API = `${BASE_CANDIDATO}/_api`

export class AccesoDatos {
  private _menu_resource: RestClient<IModelMenu>
  private _formular_resource: RestClient<IModelFormulario>

  private _edicionformularios_CLIENT: IApiRestEdicionFormularios
  private _formularios_CLIENT: IApiRestFormularios
  private _formulariosPublicios_CLIENT: IApiRestFormulariosPublicos
  private _menus_CLIENT: IApiRestMenu
  private _menusPublicos_CLIENT: IApiRestMenuPublicos
  private _pregs_CLIENT: IApiRestEdicionPreguntas
  private _mainQuestions_CLIENT: IApiRestMainQuestions
  private _curr_CLIENT: IApiRestCurriculums
  private _user_CLIENT: IApiRestLogin
  private _gestioncurr_CLIENT: IApiRestGestionCurriculums
  private _gestionsolicitudes_CLIENT: IApiRestGestionFormsInternos
  private _historic_CLIENT: IApiRestHistoricoCurriculums
  private _historicSolicitudes_CLIENT: IApiRestHistoricoFormsInternos
  private _gestionmenu_CLIENT: IApiRestGestionMenu
  private _documentacion_CLIENT: IApiRestDocumentacion
  private _gestiontextos_CLIENT: IApiRestGestionTextos
  private _datos_CLIENT: IApiRestDatos

  constructor(
    //
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoServicios: AccesoServicios
  ) {}

  private _urlRestDataApi(apipath: string) {
    return `${BASE_URL_REST_DATA_API}/${apipath}`
  }

  private _simple_resource<T>(resource: string, idprop: (e: T) => number) {
    return new RestClient<T>(this.AccesoServicios, this._urlRestDataApi(resource), resource, idprop)
  }

  get menuResource() {
    if (!this._menu_resource) this._menu_resource = this._simple_resource('modelMenus', (e: IModelMenu) => e.idmen)

    return this._menu_resource
  }

  get formularResource() {
    if (!this._formular_resource)
      this._formular_resource = this._simple_resource('modelFormularios', (e: IModelFormulario) => e.idform)

    return this._formular_resource
  }

  get EdicionFormular_CLIENT() {
    if (!this._edicionformularios_CLIENT)
      this._edicionformularios_CLIENT = new IApiRestEdicionFormulariosClient(
        this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API)
      )

    return this._edicionformularios_CLIENT
  }

  get Formular_CLIENT() {
    if (!this._formularios_CLIENT)
      this._formularios_CLIENT = new IApiRestFormulariosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._formularios_CLIENT
  }

  get FormularPublicos_CLIENT() {
    if (!this._formulariosPublicios_CLIENT)
      this._formulariosPublicios_CLIENT = new IApiRestFormulariosPublicosClient(
        this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API)
      )

    return this._formulariosPublicios_CLIENT
  }

  get Menu_CLIENT() {
    if (!this._menus_CLIENT)
      this._menus_CLIENT = new IApiRestMenuClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._menus_CLIENT
  }

  get MenuPublicos_CLIENT() {
    if (!this._menusPublicos_CLIENT)
      this._menusPublicos_CLIENT = new IApiRestMenuPublicosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._menusPublicos_CLIENT
  }

  get Preg_CLIENT() {
    if (!this._pregs_CLIENT)
      this._pregs_CLIENT = new IApiRestEdicionPreguntasClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._pregs_CLIENT
  }

  get MainQuestions_CLIENT() {
    if (!this._mainQuestions_CLIENT)
      this._mainQuestions_CLIENT = new IApiRestMainQuestionsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._mainQuestions_CLIENT
  }

  get Curr_CLIENT() {
    if (!this._curr_CLIENT)
      this._curr_CLIENT = new IApiRestCurriculumsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._curr_CLIENT
  }

  get GestionCurr_CLIENT() {
    if (!this._gestioncurr_CLIENT)
      this._gestioncurr_CLIENT = new IApiRestGestionCurriculumsClient(
        this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API)
      )

    return this._gestioncurr_CLIENT
  }

  get GestionSolicitudes_CLIENT() {
    if (!this._gestionsolicitudes_CLIENT)
      this._gestionsolicitudes_CLIENT = new IApiRestGestionFormsInternosClient(
        this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API)
      )

    return this._gestionsolicitudes_CLIENT
  }

  get HistoricCurr_CLIENT() {
    if (!this._historic_CLIENT)
      this._historic_CLIENT = new IApiRestHistoricoCurriculumsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._historic_CLIENT
  }

  get HistoricSolicitudes_CLIENT() {
    if (!this._historicSolicitudes_CLIENT)
      this._historicSolicitudes_CLIENT = new IApiRestHistoricoFormsInternosClient(
        this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API)
      )

    return this._historicSolicitudes_CLIENT
  }

  get GestionMenu_CLIENT() {
    if (!this._gestionmenu_CLIENT)
      this._gestionmenu_CLIENT = new IApiRestGestionMenuClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._gestionmenu_CLIENT
  }

  get Documentacion_CLIENT() {
    if (!this._documentacion_CLIENT)
      this._documentacion_CLIENT = new IApiRestDocumentacionClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._documentacion_CLIENT
  }

  get GestionTextos_CLIENT() {
    if (!this._gestiontextos_CLIENT)
      this._gestiontextos_CLIENT = new IApiRestGestionTextosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._gestiontextos_CLIENT
  }

  get Login_CLIENT() {
    if (!this._user_CLIENT)
      this._user_CLIENT = new IApiRestLoginClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API))

    return this._user_CLIENT
  }

  get Datos_Client() {
    return this.__get_client(
      this._datos_CLIENT,
      () => (this._datos_CLIENT = new IApiRestDatosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API)))
    )
  }

  private __get_client<T>(client: T, setter: () => T) {
    if (!client) return setter()

    return client
  }
}

angular.module('candidato').service('AccesoDatos', AccesoDatos)
